<div class="taskboard-header" *ngIf="Dialogdata.showSortButton">
    <fa-icon icon="clipboard-check" class="task-icon"></fa-icon>
    <span class="spacer"></span>
    <mat-form-field *ngIf="SearchBarActive">
        <input type="text" placeholder="Suche" [formControl]="SearchForm" matInput #input/>
        <button class="clear-search" (click)="SearchForm.setValue('')" mat-icon-button *ngIf="SearchForm.value">
            <fa-icon icon="times"></fa-icon>
        </button>
    </mat-form-field>
    <button class="ml-2" app-round-button [matTooltip]="SearchBarActive && !SearchForm.value ? 'Ausblenden' : 'Suche'" aria-label="{{SearchBarActive && !SearchForm.value ? 'Ausblenden' : 'Suche'}}" (click)="SearchButtonClicked()">
        <fa-icon [icon]="SearchBarActive && !SearchForm.value ? 'times' : 'search'"></fa-icon>
    </button>
    <button class="ml-2" app-round-button matTooltip="Sortieren" aria-label="Sortieren" [matMenuTriggerFor]="sortMenu">
        <fa-icon icon="sort"></fa-icon>
    </button>
</div>
<mat-menu #sortMenu >
    <button mat-menu-item (click)="TaskBoardSort = {sortBy: 'endDate', direction: 'asc'}"><fa-icon icon="chevron-up"></fa-icon> Frist</button>
    <button mat-menu-item (click)="TaskBoardSort = {sortBy: 'endDate', direction: 'dsc'}"><fa-icon icon="chevron-down"></fa-icon> Frist</button>
    <button mat-menu-item (click)="TaskBoardSort = {sortBy: 'priority', direction: 'asc'}"><fa-icon icon="chevron-up"></fa-icon> Priorität</button>
    <button mat-menu-item (click)="TaskBoardSort = {sortBy: 'priority', direction: 'dsc'}"><fa-icon icon="chevron-down"></fa-icon> Priorität</button>
</mat-menu>
<app-tasks-board [inlineCompleteToggleButton]="true" [Search]="SearchForm.value" [Filter]="Dialogdata?.filter" [Sort]="TaskBoardSort" (FileClicked)="OpenFile($event)"></app-tasks-board>
